import React from 'react';
import Skeleton from 'wsm-skeleton';
import { MAP_BORDER_RADIUS } from '../../constants/mapConstants';

/**
 * Skeleton placeholder for the map column.
 * Mirrors the MapSection layout (map-column → map-sticky-container → map-content)
 * so the two-column layout stays stable during loading.
 */
const MapSkeleton = () => (
	<div
		className="map-column flex-shrink-0 d-none d-lg-block"
		data-testid="map-skeleton"
	>
		<div className="map-sticky-container position-sticky w-100 ps-5">
			<Skeleton
				height="100%"
				width="100%"
				skeletonClasses="w-100 h-100"
				style={{ borderRadius: MAP_BORDER_RADIUS }}
				dataTestId="skeleton-map"
			/>
		</div>
	</div>
);

export default MapSkeleton;
